import { useState, useEffect } from 'react';
import { NetworkError } from '@CS/components/Popups';

export const useNetworkListener = () => {
  const [onLine, setOnLine] = useState(navigator.onLine);
  const checkConnection = () => setOnLine(navigator.onLine);

  useEffect(() => {
    window.addEventListener('online', checkConnection);
    window.addEventListener('offline', checkConnection);

    return () => {
      window.removeEventListener('online', checkConnection);
      window.removeEventListener('offline', checkConnection);
    };
  }, []);

  return !onLine && <NetworkError onRetry={checkConnection} />;
};
